import React from 'react'

import { InlineField, InlineLabel } from '../scharedStyles/style'
import FormSelect from '../FormSelect'

const FormField = ({ label, children }) => (
    <InlineField>
        <InlineLabel>{label}</InlineLabel>
        {children}
    </InlineField>
)

export const FormSelectField = ({
    label,
    value,
    options,
    placeholder,
    onChange,
    multiple = false,
    disabled = false,
}) => (
    <FormField label={label}>
        <FormSelect
            value={value}
            options={options}
            placeholder={placeholder}
            onChange={onChange}
            multiple={multiple}
            disabled={disabled}
        />
    </FormField>
)

export default FormField
